<template>
  <div class="options">
    <h2 class="title">{{title}}</h2>

    <div class="options__container">
      <div class="options__form">
        <product-options
          v-for="groupedCategory in State.groupedCategories"
          :key="groupedCategory.id"
          :groupedCategory="groupedCategory"
        />
      </div>

      <div class="options__summary">
        <div>
          <order-summary>
            <submit-button
              text="Ga verder"
              :checkmark="false"
              @click.prevent="next"
              @stepBack="back"
            />
          </order-summary>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductOptions from '../components/product-options'
import OrderSummary from '../components/summary'
import State from '../state'
import SubmitButton from '../components/submit-button'

export default {
  components: { ProductOptions, OrderSummary, SubmitButton },
  data () {
    return { State }
  },
  computed: {
    title: function () {
      return process.env.VUE_APP_SELECT_OPTIONS_TITLE
    }
  },
  methods: {
    next () {
      this.$emit('next')
    },
    back () {
      this.$emit('to1')
    }
  }
}
</script>

<style scoped lang="scss">
.options__container {
  display: flex;
}
.options__form {
  flex: 5;
}
.options__summary {
  flex: 2;
  & > * {
    position: sticky;
    top: 70px;
  }
}

@include mobile {
  .options__container {
    flex-direction: column;
  }
  .options__summary {
    order: -1;
    margin-bottom: 50px;
    & > * {
      position: relative;
      top: 0px;
    }
  }
}
</style>
